import Vue from 'vue'
import _debounce from 'lodash.debounce'

export default {
  namespaced: true,
  state: {
    aplID: null,
    an: null,
    trimestru: null,
    cif_op: null,
    cif_os: null,
    selectedTab: 'Executie',
    selectedTabID: 'exe la',
    tabs: [
      { label: 'Executie La', _id: 'exe la' },
      { label: 'Planificare La', _id: 'pln la' },
      { label: 'Rectificare La', _id: 'rct la' },
      { label: 'Executie In', _id: 'exe in' },
      { label: 'Planificare In', _id: 'pln in' },
      { label: 'Rectificare In', _id: 'rct in' }
    ],
    items: [],
    total: 0,
    search: null,
    pagination: {
      sortBy: 'createdAt',
      descending: true,
      page: 1,
      rowsPerPage: -1
    },
    loading: false,
    service: {
      path: 'computes-formule',
      tabField: 'perioada'
    },
    msgTemplates: {
      resource: 'sistem verificare',
      main: 'label'
    }
  },
  getters: {
    tabs: state => state.tabs,
    selectedTab: state => state.selectedTab,
    selectedTabID: state => state.selectedTabID,
    items: state => state.items ? state.items.sort((a, b) => a.cod.localeCompare(b.cod)) : [],
    total: state => state.total,
    loading: state => state.loading,
    pagination: state => state.pagination
  },
  mutations: {
    setAplID (state, payload) {
      state.aplID = payload
    },
    setAnTrimestru (state, payload) {
      state.an = payload[0]
      state.trimestru = payload[1]
    },
    setAplCifs (state, payload) {
      state.cif_op = payload.cif_op
      state.cif_os = payload.cif_os
    },
    clearState (state) {
      state.items = []
      state.aplID = null
      state.an = null
      state.trimestru = null
      state.cif_op = null
      state.cif_os = null
    },
    setSelectedTab (state, payload) {
      if (state.tabs.length && state.tabs[payload]) {
        state.selectedTab = payload
        state.selectedTabID = state.tabs[payload]._id
      }
    },
    setItems (state, payload) {
      state.items = payload
    },
    setTotal (state, payload) {
      state.total = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setPagination (state, payload) {
      Vue.set(state, 'pagination', payload)
    },
    setSortBy (state, payload) {
      Vue.set(state.pagination, 'sortBy', payload)
    },
    setSearch (state, payload) {
      state.search = payload
    }
  },
  actions: {
    setEventWatchers ({ commit, dispatch, rootState }) {
      rootState.services.cifuri.events.forEach(event => {
        rootState.services.cifuri.on(event, data => {
          commit('setLoading', true)
          dispatch('fetchItems')
        })
      })
    },
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      if (!state.pagination.sortBy) {
        commit('setSortBy', 'createdAt')
      }

      let skip = 0

      let query = {}
      if (state.pagination.rowsPerPage === -1) {
        query = {
          $paginate: false
        }
      } else {
        skip = state.pagination.rowsPerPage * (state.pagination.page - 1)
        query = {
          $limit: state.pagination.rowsPerPage,
          $skip: skip
        }
      }

      query.$sort = {
        [state.pagination.sortBy || 'createdAt']: state.pagination.descending ? -1 : 1
      }

      if (state.search && state.search.length) {
        query.$search = state.search
      }
      query.tab = state.selectedTabID
      query.cif_op = state.cif_op
      query.cif_os = state.cif_os
      query.an = state.an
      query.trimestru = state.trimestru

      rootState.feathers.service(state.service.path).find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "${state.msgTemplates.resource}" reusita. Pagina: ${state.pagination.page}, Total: ${result.total || result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        if (state.pagination.rowsPerPage === -1) {
          commit('setItems', result)
          commit('setTotal', result.length)
        } else {
          commit('setItems', result.data)
          commit('setTotal', result.total)
        }

        const { page, ...pagination } = state.pagination
        if (page > 1 && skip > result.total) {
          pagination.page = 1
          dispatch('paginationChanged', pagination)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchItems')
    },
    // paginationChanged ({ commit, dispatch }, payload) {
    //   commit('setPagination', payload)
    //   dispatch('fetchItems')
    // },
    setSelectedTab ({ state, commit, dispatch }, payload) {
      const pos = state.tabs.findIndex(tab => tab._id === payload)
      if (pos > -1) {
        commit('setItems', [])
        commit('setSelectedTab', pos)
        dispatch('fetchItems')
      }
    }
  }
}
